import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
} from "@/lib/reportPrintShell";

function sectionHtml(title, sections) {
  if (!sections?.length) {
    return `<h2>${title}</h2><p><em>No activity</em></p>`;
  }

  return sections
    .map((section) => {
      const rows = section.accounts
        .map(
          (a) => `
        <tr>
          <td class="mono">${a.code}</td>
          <td>${a.name}</td>
          <td class="num">${aed(a.amount)}</td>
        </tr>`,
        )
        .join("");

      return `
      <h3>${section.schedule_name}</h3>
      <table>
        <thead><tr><th>Code</th><th>Account</th><th>Amount</th></tr></thead>
        <tbody>${rows}</tbody>
        <tfoot><tr><th colspan="2">Subtotal</th><th class="num">${aed(section.subtotal)}</th></tr></tfoot>
      </table>`;
    })
    .join("");
}

export async function printProfitLoss(report, title = "Profit & Loss", options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };
  const company = await resolveReportLetterhead({ branchId: withBranch.branch_id, allBranches: withBranch.all_branches });

  const html = buildReportDocument({
    title,
    company,
    metaHtml: periodMeta(withBranch),
    bodyHtml: `<h2>Income</h2>
  ${sectionHtml("Income", withBranch.income_sections)}
  <h2>Expenses</h2>
  ${sectionHtml("Expenses", withBranch.expense_sections)}
  <table class="summary">
    <tr><th>Total Income</th><td class="num">${aed(withBranch.total_income)}</td></tr>
    <tr><th>Total Expenses</th><td class="num">${aed(withBranch.total_expenses)}</td></tr>
    <tr><th>Net Profit / (Loss)</th><td class="num">${aed(withBranch.net_profit)}</td></tr>
  </table>`,
  });

  return openReportPrint(html);
}
